<script setup>
function onEnter (el) {
  el.style.height = '0'
  requestAnimationFrame(() => {
    el.style.height = el.scrollHeight + 'px'
  })
}
function onAfterEnter (el) {
  el.style.height = ''
}
function onLeave (el) {
  el.style.height = el.scrollHeight + 'px'
  requestAnimationFrame(() => {
    el.style.height = '0'
  })
}
</script>

<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-in-out overflow-hidden"
    leave-active-class="transition-all duration-300 ease-in-out overflow-hidden"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @leave="onLeave"
  >
    <slot />
  </Transition>
</template>
